import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["notification"]
  static values = { dismissAfter: { type: Number, default: 6000 } }

  connect() {
    requestAnimationFrame(() => {
      this.notificationTarget.classList.remove("translate-x-full", "opacity-0")
      this.notificationTarget.classList.add("translate-x-0", "opacity-100")
    })

    if (this.dismissAfterValue > 0) {
      this.timeout = setTimeout(() => this.dismiss(), this.dismissAfterValue)
    }
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  dismiss() {
    clearTimeout(this.timeout)
    this.notificationTarget.classList.remove("translate-x-0", "opacity-100")
    this.notificationTarget.classList.add("translate-x-full", "opacity-0")

    setTimeout(() => this.element.remove(), 300)
  }
}
